import type { ReactNode } from 'react'
import { I18nextProvider } from 'react-i18next'

import i18n from '@/lib/i18n'
import { RealtimeProvider, type RealtimeManager } from '@/lib/realtime'
import { useGateStore } from '@/features/auth/state/gate-store'

/**
 * App-level providers. Intentionally no server-state cache (D-042): React
 * Router loaders/actions own request lifecycles. Add providers here only for
 * true cross-cutting concerns (i18n, realtime connection lifecycle, future
 * theme/gesture context).
 */
export function AppProviders({
  children,
  realtime,
}: {
  children: ReactNode
  /** Test seam so feature tests can drive a fake WebSocket. */
  realtime?: RealtimeManager
}) {
  const suspended = useGateStore(
    (state) => state.termsRequired || Boolean(state.update?.required),
  )

  return (
    <I18nextProvider i18n={i18n}>
      <RealtimeProvider manager={realtime} suspended={suspended}>
        {children}
      </RealtimeProvider>
    </I18nextProvider>
  )
}
